export default __webpack_public_path__ + "static/media/CoolEarth.7b73f8cf5f34537e955886fae0453bb9.webp";